import { render, staticRenderFns } from "./reports.edit.component.vue?vue&type=template&id=2f898232&scoped=true&"
import script from "./reports.edit.component.vue?vue&type=script&lang=ts&"
export * from "./reports.edit.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f898232",
  null
  
)

export default component.exports